<template>
  <transition name="plate">
    <div class="plate" :class="computedClasses" v-if="props.isShow" ref="plateElement">
      <div class="plate__left-addons" v-if="isLeftAddon">
        <slot name="leftAddon"></slot>
      </div>
      <div class="plate__content">
        <div class="plate__wrapper">
          <div class="plate__title" v-if="isTitleSlot">
            <slot name="titleSlot"></slot>
          </div>
          <div class="plate__subtitle" v-if="isSubtitleSlot">
            <slot name="subtitleSlot"></slot>
          </div>
          <div class="plate__text" v-if="isText">
            <slot name="text"></slot>
          </div>
        </div>
        <div class="plate__addons-control" v-if="isControlsAddons">
          <slot name="controlsAddons"></slot>
        </div>
      </div>
      <div class="plate__right-addons" v-if="isRightAddon">
        <slot name="rightAddon"></slot>
      </div></div
  ></transition>
</template>

<script lang="ts" setup>
import { PropType, computed, onMounted, ref, useSlots } from "vue";
/**
 * Пропсы
 */
const props = defineProps({
  /**
   * Скруглен полностью
   */
  variant: {
    type: String as PropType<"default" | "attention" | "negative" | "positive">,
    default: "default",
  },
  /**
   * Скруглен полностью
   */
  positionControlAddons: {
    type: String as PropType<"right" | "bottom">,
    default: "right",
  },
  /**
   * Показывать ли активное состояние
   */
  isShow: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Скруглены ли края
   */
  isRounded: { type: Boolean as PropType<boolean>, default: false },

  /**
   * С границами или нет
   */
  isBordered: { type: Boolean as PropType<boolean>, default: false },
});

const emit = defineEmits(["update:modelValue", "check"]);

/**
 * Слоты
 */
const slots = useSlots();
/**
 * Левый аддон
 */
const isLeftAddon = computed(() => slots && slots.leftAddon && slots.leftAddon());
/**
 * Левый аддон
 */
const isRightAddon = computed(() => slots && slots.rightAddon && slots.rightAddon());
/**
 * Заголовок
 */
const isTitleSlot = computed(() => slots && slots.titleSlot && slots.titleSlot());
/**
 * Подзаголовок
 */
const isSubtitleSlot = computed(() => slots && slots.subtitleSlot && slots.subtitleSlot());

/**
 * Текст
 */
const isText = computed(() => slots && slots.text && slots.text());

/**
 * Классы из пропсов
 */

const computedClasses = computed(() => {
  return {
    "plate--show": props.isShow,
    "plate--addons-conntrols-position-right": props.positionControlAddons == "right",
    "plate--addons-conntrols-position-bottom": props.positionControlAddons == "bottom",
    "plate--variant-default": props.variant == "default",
    "plate--variant-attention": props.variant == "attention",
    "plate--variant-negative": props.variant == "negative",
    "plate--variant-positive": props.variant == "positive",
    "plate--rounded": props.isRounded,
    "plate--bordered": props.isBordered,
  };
});
const isControlsAddons = computed(() => slots && slots.controlsAddons && slots.controlsAddons());

const elementHeight = ref<number>();
const plateElement = ref(null);

console.log("errwdadwwadaw", plateElement.value);

onMounted(() => {});
</script>

<style lang="scss">
@import "./style.scss";
</style>
